import { render, staticRenderFns } from "./EditCardholder.vue?vue&type=template&id=63853f4f"
import script from "./EditCardholder.vue?vue&type=script&lang=js"
export * from "./EditCardholder.vue?vue&type=script&lang=js"
import style0 from "./EditCardholder.vue?vue&type=style&index=0&id=63853f4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports